import React, { useEffect } from 'react';
import NumberFormat from 'react-number-format';
import ButtonToolbar from 'react-bootstrap/ButtonToolbar';
import ToggleButtonGroup from 'react-bootstrap/ToggleButtonGroup';
import ToggleButton from 'react-bootstrap/ToggleButton';
import { useField } from 'formik';
import { mapping as genderMapping } from './GenderField';
import CaliperMeasurementsField from './CaliperMeasurementsField';

export const mapping = {
  textMethod: { label: 'Text Input', value: 'text' },
  caliperMethod: {
    label: 'Smart Caliper',
    value: 'caliper',
    jp3: { label: 'J/P 3', value: 'jp3' },
    jp7: { label: 'J/P 7', value: 'jp7' },
    parillo9: { label: 'Parillo 9', value: 'parillo9' },
    measurements: {
      chest: { label: 'Chest', value: 'chest' },
      abdominal: { label: 'Abdominal', value: 'abdominal' },
      thigh: { label: 'Thigh', value: 'thigh' },
      subscapular: { label: 'Subscapular', value: 'subscapular' },
      tricep: { label: 'Tricep', value: 'tricep' },
      suprailiac: { label: 'Suprailiac', value: 'suprailiac' },
      midaxillary: { label: 'Axilla', value: 'midaxillary' },
      lower_back: { label: 'Lower back', value: 'lower_back' },
      calf: { label: 'Calf', value: 'calf' },
      bicep: { label: 'Bicep', value: 'bicep' }
    }
  }
};

export default function BodyFatPercentageField({
  bodyFatPercentageFieldName,
  fatPercentagePlaceholder = '0%',
  genderFieldName,
  birthdateYearFieldName,
  weightValueFieldName,
  weightUnitFieldName
}) {
  const [methodField, , methodFieldHelpers] = useField(
    `${bodyFatPercentageFieldName}.method`
  );
  const [genderField] = useField(genderFieldName);

  useEffect(() => {
    if (genderField.value === genderMapping.other.value) {
      methodFieldHelpers.setValue(mapping.textMethod.value);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [genderField.value]);

  return (
    <div className="body-fats">
      <div className="body-fats-options">
        <div className="form-group form-group-fats">
          <label className="form-label form-label-lg">
            Body Fat Percentage
          </label>
          {methodField.value === mapping.textMethod.value ? (
            <TextInputField
              fieldName={`${bodyFatPercentageFieldName}.textFatPercentage`}
              fieldPlaceholder={fatPercentagePlaceholder}
            />
          ) : (
            <CaliperMethodsField
              fieldName={`${bodyFatPercentageFieldName}.caliperMethod`}
            />
          )}
        </div>
        {genderField.value !== genderMapping.other.value && (
          <MethodToggleField methodField={methodField} />
        )}
      </div>
      {methodField.value === mapping.caliperMethod.value && (
        <CaliperMeasurementsField
          bodyFatPercentageFieldName={bodyFatPercentageFieldName}
          genderFieldName={genderFieldName}
          birthdateYearFieldName={birthdateYearFieldName}
          weightValueFieldName={weightValueFieldName}
          weightUnitFieldName={weightUnitFieldName}
          caliperMethodMapping={mapping.caliperMethod}
        />
      )}
    </div>
  );
}

function TextInputField({ fieldName, fieldPlaceholder }) {
  const [field, meta] = useField(fieldName);
  return (
    <div className="form-inline unit-field">
      <NumberFormat
        type="text"
        allowNegative={false}
        {...field}
        placeholder={fieldPlaceholder}
        className="form-control"
        isAllowed={values => values.value === '' || values.floatValue <= 100}
      />
      <span> %</span>
      {meta.touched && meta.error && (
        <div className="input-feedback">{meta.error}</div>
      )}
    </div>
  );
}

function MethodToggleField({ methodField }) {
  return (
    <div className="form-check-inline">
      <MethodItem
        methodField={methodField}
        methodMapping={mapping.textMethod}
      />
      <MethodItem
        methodField={methodField}
        methodMapping={mapping.caliperMethod}
      />
    </div>
  );
}

function CaliperMethodsField({ fieldName }) {
  const [field, meta] = useField(fieldName);

  return (
    <div className="default-btn-toolbar default-btn-toolbar-sm">
      <ButtonToolbar>
        <ToggleButtonGroup
          type="radio"
          defaultValue={meta.initialValue}
          {...field}
        >
          <ToggleButton {...field} value={mapping.caliperMethod.jp3.value}>
            {mapping.caliperMethod.jp3.label}
          </ToggleButton>
          <ToggleButton {...field} value={mapping.caliperMethod.jp7.value}>
            {mapping.caliperMethod.jp7.label}
          </ToggleButton>
          <ToggleButton {...field} value={mapping.caliperMethod.parillo9.value}>
            {mapping.caliperMethod.parillo9.label}
          </ToggleButton>
        </ToggleButtonGroup>
      </ButtonToolbar>
    </div>
  );
}

function MethodItem({ methodField, methodMapping }) {
  return (
    <div className="form-check">
      <label className="form-check-label">
        <input
          type="radio"
          className="form-check-input"
          {...methodField}
          value={methodMapping.value}
          checked={methodField.value === methodMapping.value}
        />
        <span>
          <i className="far fa-square"></i> {methodMapping.label}
        </span>
      </label>
    </div>
  );
}
